export const determineStrictPasswordScore = (password) => {
    const containsLetter = /[a-zA-Z]/;
    const containsNumber = /[0-9]/;
    const containsSpecialCharacter = /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/;
    // Shoud not have whitespace because deep in the .net auth code
    // the password is trimmed.
    // Historically Cognito didnt allow spaces also, but this part of cognito
    // is no longer used.
    const containsWhitespace = /\s/;

    let baseScore = 0;
    if (password.match(containsLetter)) baseScore++;
    if (password.match(containsNumber)) baseScore++;
    if (password.match(containsSpecialCharacter)) baseScore++;

    if (!password.match(containsWhitespace)) baseScore++;
    if (password.length < 8) baseScore = password.length ? 1 : 0;
    return baseScore;
};

export const determineIfPasswordIsTooRepetitive = (password) => {
    let lastChar;
    let repeatCounter = 1;
    for (let i = 0; i < password.length; i++) {
        const nextChar = password.charAt(i);
        if (lastChar) {
            if (lastChar === nextChar) {
                repeatCounter++;
            } else {
                lastChar = nextChar;
                repeatCounter = 1;
            }
        } else {
            lastChar = nextChar;
        }
        if (repeatCounter >= 4) {
            return true;
        }
    }
    return false;
};
